import { render, staticRenderFns } from "./Formation.vue?vue&type=template&id=16680070&scoped=true"
import script from "./Formation.vue?vue&type=script&lang=js"
export * from "./Formation.vue?vue&type=script&lang=js"
import style0 from "./Formation.vue?vue&type=style&index=0&id=16680070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16680070",
  null
  
)

export default component.exports